export const WEEKS_AND_CINEMAS_REQUESTED = 'WEEKS_AND_CINEMAS_REQUESTED';
export const WEEKS_AND_CINEMAS_SUCCEDED = 'WEEKS_AND_CINEMAS_SUCCEDED';
export const WEEKS_AND_CINEMAS_FAILED = 'WEEKS_AND_CINEMAS_FAILED';

export const WEEK_DETAILS_REQUESTED = 'WEEK_DETAILS_REQUESTED';
export const WEEK_DETAILS_SUCCEDED = 'WEEK_DETAILS_SUCCEDED';
export const WEEK_DETAILS_FAILED = 'WEEK_DETAILS_REQUESTED';

export const FILM_DETAILS_REQUESTED = 'FILM_DETAILS_REQUESTED';
export const FILM_DETAILS_SUCCEDED = 'FILM_DETAILS_SUCCEDED';
export const FILM_DETAILS_FAILED = 'FILM_DETAILS_FAILED';

export const SELECT_CINEMA = 'SELECT_CINEMA';
export const SELECT_WEEK = 'SELECT_WEEK';
export const SELECT_DATE = 'SELECT_DATE';
export const SEARCH_MOVIE = 'SEARCH_MOVIE';
export const SELECT_VIEW = 'SELECT_VIEW';
export const TABLE_REQUESTED = 'TABLE_REQUESTED';
export const CHANGE_DATE = 'CHANGE_DATE';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const GET_CURRENT_TIME = 'GET_CURRENT_TIME';
export const REMOVE_SEARCH_FIELD = 'REMOVE_SEARCH_FIELD';
export const SET_BRAND = 'SET_BRAND';
